/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React from "react";
import {
  fetchStockHistoryDownload,
  useInventoryStockHistory,
} from "../../../../../api/inventory/use-inventory-detail";
import Table from "../../../../../components/ui/Table/Table";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "일시",
      cell: (info) => {
        const val = info.getValue();
        const datetime = dayjs(val).format("YYYY-MM-DD HH:mm");
        return <div>{val ? datetime : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "내역",
      cell: (info) => {
        const hospitalName =
          info.getValue().productOrder?.productOrderParent?.hospitalMember
            ?.hospital?.name;
        const hospitalMemberEmail =
          info.getValue().productOrder?.productOrderParent?.hospitalMember
            ?.email;

        const type = info.getValue().type;
        const memo = info.getValue().description;
        const translatedValue = () => {
          switch (type) {
            case "IN_MANUAL":
              return "입고 : 수동 등록";
            case "IN_SMART":
              return "입고 : 스마트팩토리 연동";
            case "IN_EXCHANGE":
              return (
                <span>
                  입고 : 교환(재입고) <br /> {hospitalName} (
                  {hospitalMemberEmail})
                </span>
              );
            case "IN_RETURN":
              return (
                <span>
                  입고 : 반품(재입고) <br /> {hospitalName} (
                  {hospitalMemberEmail})
                </span>
              );
            case "IN_DEFECTIVE":
              return (
                <span>
                  입고 : 불량재고 (폐기예정) <br /> {hospitalName} (
                  {hospitalMemberEmail})
                </span>
              );
            case "ADJUSTMENT_OUT":
              return "조정 : (-) 조정수량";
            case "ADJUSTMENT_IN":
              return "조정 : (+) 조정수량";
            case "OUT_OTHER_SHIPMENTS":
              return (
                <span>
                  출고 : 기타 출고 <br />
                  {memo}
                </span>
              );
            case "OUT_MANUAL_INVENTORY":
              return (
                <span>
                  출고 : 수동(재고) <br /> {hospitalName} ({hospitalMemberEmail}
                  )
                </span>
              );
            case "OUT_AUTOMATIC_INVENTORY":
              return (
                <span>
                  출고 : 자동(재고) <br /> {hospitalName} ({hospitalMemberEmail}
                  )
                </span>
              );
            case "OUT_DEFECTIVE_STOCK":
              return (
                <span>
                  출고 : 불량재고 (교환) <br /> {hospitalName} (
                  {hospitalMemberEmail})
                </span>
              );
            case "OUT_MANUAL_MALL":
              return (
                <span>
                  출고 : 수동(원데이몰) <br /> {hospitalName} (
                  {hospitalMemberEmail})
                </span>
              );
            default:
              break;
          }
        };
        return <div>{type ? translatedValue() : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.productLot.productLotInfo.lotNo, {
      header: "LOT 재고 정보",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.previousStock, {
      header: "이전 재고",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.in, {
      header: "입고",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              <span className={`${val < 0 ? "text-[#e80000]" : ""}`}>
                {val}
              </span>
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row.out, {
      header: "출고",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              <span className={`${val < 0 ? "text-[#e80000]" : ""}`}>
                {val}
              </span>
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row.adjustment, {
      header: "조정",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              <span className={`${val < 0 ? "text-[#e80000]" : ""}`}>
                {val}
              </span>
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row.currentStock, {
      header: "잔여 재고",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),
  ];
};

export function StockHistoryTable(props) {
  const { filter, id, isEmptyStock, isResettedPage } = props;
  const { isEmpty, getDataTableProps } = useInventoryStockHistory(filter, id);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll;

  const onSave = async () => {
    await fetchStockHistoryDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `product-stock-histories-${id}-${Date.now()}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
    });
  };
  return (
    <>
      {isEmpty && !isEmptyStock ? (
        <div className=" mt-[60px] text-[#999999]">
          등록된 내역이 없습니다. <br />
          먼저 LOT 재고 연동을 해주세요.
          <br />
          <div className="my-2" />
          ※ 재고 상세내역에 LOT 재고 연동 방법 <br />
          1. 스마트팩토리 재고 연동 <br />☞ 재고관리 {">"} 스마트팩토리 업데이트
          확인 팝업 → [스마트팩토리 API - 일괄 재고 연동하기] 진행 <br />
          2. Admin에서 직접 재고 수동 연동
          <br />☞ 재고관리 {">"} 재고 상세내역 : LOT 재고 연동 팝업 → 수동 등록
          탭 '연동하기' → LOT 재고 연동(수동 등록) 팝업 → 해당 재고 상품 QR 스캔
        </div>
      ) : (
        <>
          <Table
            emptyStateInTableBody={
              isEmptyStock ? (
                <div className="p-4 flex text-left text-[#999999]">
                  <div>
                    등록된 내역이 없습니다.
                    <br />
                    먼저 LOT 재고 연동을 해주세요.
                    <br />
                    <div className="mt-4 mb-6">
                      <span className=" font-bold">
                        ※ 재고 상세내역에 LOT 재고 연동 방법
                      </span>
                      <br />
                      <span className="font-bold">
                        1. 스마트팩토리 재고 연동
                      </span>
                      <br />
                      <div className="ml-3">
                        ☞ 재고관리 {">"} 스마트팩토리 업데이트 확인 팝업 →
                        [스마트팩토리 API - 일괄 재고 연동하기] 진행
                      </div>
                      <span className="font-bold">
                        {" "}
                        2. Admin에서 직접 재고 수동 연동
                      </span>
                      <br />
                      <div className="ml-3">
                        ☞ 재고관리 {">"} 재고 상세내역 : LOT 재고 연동 팝업 →
                        수동 등록 탭 '연동하기' → LOT 재고 연동(수동 등록) 팝업
                        → 해당 재고 상품 QR 스캔
                      </div>
                    </div>{" "}
                  </div>
                </div>
              ) : null
            }
            emptyColSpan={9}
            boldColumns={["이전 재고", "조정"]}
            hasSort={false}
            hasPageSizeFilter={false}
            hasPagination={isEmptyStock ? false : true}
            hasSave={isEmptyStock ? false : true}
            onSave={onSave}
            isResettedPage={isResettedPage}
            columns={columns(currentPage, pageSize, totalData)}
            {...getDataTableProps()}
          />
        </>
      )}
    </>
  );
}
